import { lumi } from '@/lib/lumi'

export interface ModuleMaterial {
  _id: string
  courseId: string
  courseSlug: string
  moduleId: string
  pdfUrl?: string
  pdfName?: string
  geeUrl?: string
  zoomUrl?: string
  creator?: string
  createdAt: string
  updatedAt: string
}

function nowIso() {
  return new Date().toISOString()
}

export async function fetchCourseMaterials(courseId: string) {
  const { list } = await lumi.entities.module_materials.list({
    filter: { courseId },
    sort: { updatedAt: -1 },
    limit: 100,
  })
  return (list ?? []) as ModuleMaterial[]
}

export function materialForModule(list: ModuleMaterial[], moduleId: string) {
  return list.find((item) => item.moduleId === moduleId)
}

export async function uploadPresentationPdf(file: File) {
  if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
    throw new Error('Solo se aceptan archivos PDF.')
  }
  const results = await lumi.tools.file.upload([file])
  const first = results?.[0]
  if (!first?.fileUrl) {
    throw new Error(first?.uploadError || 'No se pudo subir el PDF.')
  }
  return { url: first.fileUrl, name: first.fileName || file.name }
}

export async function saveModuleMaterial(payload: {
  existingId?: string
  courseId: string
  courseSlug: string
  moduleId: string
  pdfUrl?: string
  pdfName?: string
  geeUrl: string
  zoomUrl: string
  creator: string
}) {
  const stamp = nowIso()
  const data = {
    courseId: payload.courseId,
    courseSlug: payload.courseSlug,
    moduleId: payload.moduleId,
    pdfUrl: payload.pdfUrl || '',
    pdfName: payload.pdfName || '',
    geeUrl: payload.geeUrl.trim(),
    zoomUrl: payload.zoomUrl.trim(),
    creator: payload.creator,
    updatedAt: stamp,
  }

  if (payload.existingId) {
    if (typeof payload.existingId !== 'string' || payload.existingId === '[object Object]') {
      throw new Error('ID inválido')
    }
    return (await lumi.entities.module_materials.update(payload.existingId, data)) as ModuleMaterial
  }

  return (await lumi.entities.module_materials.create({
    ...data,
    createdAt: stamp,
  })) as ModuleMaterial
}
